import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { ArrowUpRight } from "lucide-react";

const FOOTER_NAV = [
  { to: "/products", key: "products" },
  { to: "/services", key: "services" },
  { to: "/projects", key: "projects" },
  { to: "/about", key: "about" },
  { to: "/contact", key: "contact" },
];

export const Footer = () => {
  const { t } = useLang();

  return (
    <footer className="bg-[#1A1A1A] text-[#F9F8F6] relative overflow-hidden" data-testid="site-footer">
      <div className="px-6 lg:px-12 pt-20 pb-10 max-w-[1400px] mx-auto">
        <div className="font-display text-[18vw] lg:text-[14vw] leading-[0.8] tracking-tighter font-light">
          Pick
          <span className="text-[#8A5A44]">.</span>
        </div>
        <div className="font-display text-[8vw] lg:text-[5vw] leading-[0.85] tracking-tighter font-extralight italic mt-2 text-[#F9F8F6]/70">
          Bodenbeläge
        </div>
        <p className="mt-8 max-w-md text-sm text-[#F9F8F6]/65">{t("footer.tagline")}</p>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 grid grid-cols-2 lg:grid-cols-4 gap-10 text-sm">
          <div>
            <div className="text-[10px] tracking-[0.25em] uppercase opacity-60 mb-4">{t("footer.links_title")}</div>
            <ul className="space-y-3">
              {FOOTER_NAV.map((n) => (
                <li key={n.key}>
                  <Link to={n.to} className="link-underline text-[#F9F8F6]/85" data-testid={`footer-link-${n.key}`}>
                    {t(`nav.${n.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.25em] uppercase opacity-60 mb-4">{t("footer.contact_title")}</div>
            <ul className="space-y-3 text-[#F9F8F6]/85">
              <li>Schultenhofstraße 46</li>
              <li>45475 Mülheim a. d. Ruhr</li>
              <li><a href="tel:+4920873068" className="link-underline">+49 208 73068</a></li>
              <li>
                <a href="https://teppichpick.de" target="_blank" rel="noopener noreferrer" className="link-underline inline-flex items-center gap-1">
                  teppichpick.de <ArrowUpRight size={12} />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.25em] uppercase opacity-60 mb-4">Öffnungszeiten</div>
            <ul className="space-y-3 text-[#F9F8F6]/85">
              <li>Mo–Fr · 09:00 – 18:00</li>
              <li>Sa · 10:00 – 14:00</li>
              <li>So · geschlossen</li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.25em] uppercase opacity-60 mb-4">{t("footer.legal_title")}</div>
            <ul className="space-y-3 text-[#F9F8F6]/85">
              <li><a href="#" className="link-underline">{t("footer.imprint")}</a></li>
              <li><a href="#" className="link-underline">{t("footer.privacy")}</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[#F9F8F6]/55">
          <span>© {new Date().getFullYear()} — {t("footer.copyright")}</span>
          <span>Crafted with care · E1</span>
        </div>
      </div>
    </footer>
  );
};
